import { Box, Paper, Typography, Link as MuiLink } from "@mui/material";
import { makeRequest } from "../assets/functions_helper";
import { useState } from "react";
import { ButtonAnimated } from "../components/resources";
import SendIcon from "@mui/icons-material/Send";
import SnackBar from "../components/snackBar";
import { CustomTextField } from "../components/textFields";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [emailSended, setEmailSended] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendEmailToForgotPassword = () => {
    // Validación simple de email
    const emailRegex = /^[^\s@]+@([^\s@]+\.)+[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      setSnackBarOpen(true);
      setSnackBarMessage("Por favor ingresa un correo electrónico válido.");
      return;
    }

    setLoading(true);
    makeRequest(
      "POST",
      `users/forgot_password?email=${email}`,
      { email },
      "application/json",
      null,
      null,
      null,
      null,
      () => {
        console.log("Error");
      }
    )
      .then((response) => {
        setSnackBarOpen(true);
        setSnackBarMessage(
          "Correo enviado. Por favor revisa tu bandeja de entrada (y spam) para restablecer tu contraseña."
        );
        setEmailSended(true);
        setLoading(false);
      })
      .catch((error) => {
        setSnackBarOpen(true);
        setSnackBarMessage("Error al enviar el correo. Inténtalo de nuevo más tarde.");
        setLoading(false);
      });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f5f7fa 0%, #e9eef3 100%)",
        padding: 2,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{ width: "100%", maxWidth: 450 }}
      >
        <Paper
          elevation={6}
          sx={{
            p: { xs: 3, sm: 5 },
            borderRadius: 4,
            textAlign: "center",
            backgroundColor: "white",
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
          }}
        >
          {!emailSended ? (
            <>
              <Typography
                variant="h5"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: 700,
                  color: "#1E1E2F",
                  fontFamily: "Como, sans-serif",
                }}
              >
                ¿Olvidaste tu contraseña?
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mb: 3,
                  color: "#6B7280",
                  fontFamily: "Como, sans-serif",
                }}
              >
                Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
              </Typography>

              <CustomTextField
                fullWidth
                label="Correo electrónico"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                sx={{ mb: 3 }}
                autoFocus
              />

              <ButtonAnimated
                onClick={handleSendEmailToForgotPassword}
                variant="contained"
                disabled={loading}
                startIcon={<SendIcon />}
                sx={{
                  backgroundColor: "#FF4747",
                  color: "white",
                  fontWeight: 600,
                  py: 1.2,
                  px: 3,
                  borderRadius: "28px",
                  textTransform: "none",
                  fontSize: "1rem",
                  "&:hover": {
                    backgroundColor: "#ff47478e",
                  },
                  "&:disabled": {
                    backgroundColor: "#b0c4de",
                  },
                  width: "100%",
                }}
              >
                {loading ? "Enviando..." : "Enviar enlace"}
              </ButtonAnimated>

              <Box sx={{ mt: 3 }}>
                <MuiLink
                  component={Link}
                  to="/login"
                  underline="hover"
                  sx={{
                    color: "#4EACDA",
                    fontFamily: "Como, sans-serif",
                    fontSize: "0.875rem",
                    cursor: "pointer",
                  }}
                >
                  ← Volver al inicio de sesión
                </MuiLink>
              </Box>
            </>
          ) : (
            <>
              <Typography
                variant="h5"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: 700,
                  color: "#1E1E2F",
                  fontFamily: "Como, sans-serif",
                }}
              >
                ¡Revisa tu correo!
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mb: 2,
                  color: "#6B7280",
                  fontFamily: "Como, sans-serif",
                }}
              >
                Hemos enviado un enlace para restablecer tu contraseña a{" "}
                <strong>{email}</strong>. Si no lo encuentras, revisa la carpeta de spam.
              </Typography>
              <ButtonAnimated
                component={Link}
                to="/login"
                variant="contained"
                sx={{
                  backgroundColor: "#f73541",
                  color: "white",
                  fontWeight: 600,
                  py: 1.2,
                  px: 3,
                  borderRadius: "28px",
                  textTransform: "none",
                  fontSize: "1rem",
                  width: "100%",
                  "&:hover": {
                    backgroundColor: "#f7354298",
                  },
                }}
              >
                Ir al inicio de sesión
              </ButtonAnimated>
            </>
          )}
        </Paper>
      </motion.div>

      <SnackBar
        openSnackBar={snackBarOpen}
        setOpenSnackBar={setSnackBarOpen}
        messageSnackBar={snackBarMessage}
      />
    </Box>
  );
}

export default ForgotPassword;